type CreateSteps = {
  Configure: number;
  Contacts: number;
  Templates: number;
  TemplateUsers: number;
  Packs: number;
  AddOn: number;
  Notify: number;
};

export const getCreateSteps = (templates: boolean, templateUsers: boolean): CreateSteps => {
  let index = 0;
  const result: CreateSteps = {} as CreateSteps;
  const add = (step: keyof CreateSteps) => {
    result[step] = index++;
  };
  add("Configure");
  add("Contacts");
  if (templates) {
    add("Templates");
  }
  if (templateUsers) {
    add("TemplateUsers");
  }
  add("Packs");
  add("AddOn");
  add("Notify");
  return result;
};
